import { Component, OnInit, ViewChild } from '@angular/core';
import { Param } from './param';
import { ParamService } from './param.service';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { StatusService } from '../status/status.service';
import { Status } from '../status/status';

@Component({
    templateUrl: './param.component.html'
})

export class ParamComponent implements OnInit {

    @ViewChild('myTable') myTable;

    items: Param[] = [];
    item: Param = new Param();
    outItem: Param;
    selectedItem: Param;
    msgs: Message[] = [];
    statuslist: Status[] = [];

    constructor(
        private activatedRoute: ActivatedRoute,
        private service: ParamService,
        private statusService: StatusService,
    ) { }

    ngOnInit() {
        this.statusService.findAll().subscribe(status => {
            this.statuslist = status.filter(x => x.type == "Master");
        });

        this.activatedRoute.params.subscribe(params => {
            this.items = this.activatedRoute.snapshot.data['items'];
        });
    }

    newItem() {
        this.msgs = [];
        this.selectedItem = { id: null, upLimit: null, status: null};
        this.items = [this.selectedItem].concat(this.items);
        this.myTable.first = 0;
    }

    delete(item: Param) {
        this.msgs = [];
        if (item.id != null){
           this.service.delete(item).subscribe( (data) => {
            const deletedItem = this.items.find(x => x.id === item.id);
            this.items.splice(this.items.indexOf(deletedItem), 1);
            this.msgs.push({
                severity: 'success',
                detail: 'Registro excluído'
            });
           }, (err) => {
            this.msgs.push({
                severity: 'error',
                detail: 'Não é possível excluir o registro'
            });
           });
        }
    }

    save(item: Param) {
        this.msgs = [];
        if (item.upLimit == null) this.msgs.push({severity:'error', detail:'Limite obrigatório'});
        if (item.status == null) this.msgs.push({severity:'error', detail:'Status obrigatório'});

        if (this.msgs.length > 0)
            return;

        if (item.id == null){
            this.service.save(item).subscribe( params => {
                item.id = params.id;

                this.service.findAll().subscribe(params => {
                    this.items = params;
                });
                this.msgs.push({
                    severity: 'success',
                    detail: 'Registro incluído'
                });
            });
        } else {
            this.service.update(item).subscribe((data) => {
                this.service.findAll().subscribe(params => {
                    this.items = params;
                });
                this.msgs.push({
                    severity: 'success',
                    detail: 'Registro modificado'
                });
            });
        }
        this.selectedItem = null;
    }

    cancel(item: Param) {
        this.msgs = [];
        if (this.selectedItem.id == null) {
            this.items.shift();
        }

        if(this.outItem != null && this.outItem.id != null){
            item.upLimit = this.outItem.upLimit;
            item.status = this.outItem.status;
        }

        this.selectedItem = null;
        this.outItem = null;
    }

    edit(item: Param) {
        this.msgs = [];
        this.selectedItem = item;
        this.outItem = this.clone(item);
    }

    clone(i: Param): Param{
        let item = {id: null, upLimit: null, status:null};
        for(let prop in i){
            item[prop] = i[prop];
        }
        return item;
    }

}